module.exports = __webpack_public_path__ + "static/img/monitor_item_image3.8443552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_item_image3.png
// module id = rOMo
// module chunks = 1